<template>
  <v-dialog v-model="showDialog" persistent width="unset" hide-overlay>
    <v-card class="pa-0">
      <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
      <v-card-text>
        <v-form ref="myRef">
          <v-container>
            <v-text-field
                v-model="textField"
                :label="addTextFieldLabel"
                outlined
            />
            <v-text-field
                v-model="textFieldLastName"
                :label="addTextFieldLastNameLabel"
                outlined
            />
            {{ dialogText }}
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="error"
            @click="closeDialog()"
        >{{ button1Text }}
        </v-btn>
        <v-btn
            color="primary"
            @click="clickedButton2()"
        >{{ button2Text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EMailSendConfirmationDialog",
  data() {
    return {
      showDialog: false,
      textField: "",
      textFieldLastName: "",
    }
  },
  methods: {
    closeDialog() {
      this.showDialog=false;
      this.$refs.myRef.reset();
    },
    clickedButton2() {
      this.showDialog=false;
      this.$emit('clickedButton2');
    }
  },
  props: {
    dialogTitle: String,
    addTextFieldLabel: String,
    addTextFieldLastNameLabel: String,
    dialogText: String,
    button1Text: String,
    button2Text: String
  }
}
</script>

<style scoped>

</style>